export default "__VITE_ASSET__CI89$qM1__"